import React, { useEffect, useState } from "react";
import "./Checkbox.css";

const CheckBoxYesNo = ({ Ref, defaultChecked = false, onChange, label, value }) => {
  const isControlled = value !== undefined;
  const [checked, setChecked] = useState(defaultChecked);

  useEffect(() => {
    if (isControlled) {
      setChecked(value);
    }
  }, [value]);

  const handleChange = (val)=> () => {
    value === undefined && setChecked(val);
    onChange && onChange(val);
  };

  return (
    <div className={`[&>.checked]:bg-[var(--inyc-secondary)] flex justify-center items-center gap-kit-16`}>
      <div className={`flex items-center bg-transparent min-w-[30px] cursor-pointer `}>
        <input className="checkbox" type="checkbox" ref={Ref} checked={checked} />
        <div className="flex gap-kit-6 items-center justify-start">
          <div onClick={handleChange(true)} className={`checkbox-yes-no-option duration-200 font-bold rounded-kit-2xl border border-[var(--inyc-outline-color)] px-kit-12 py-kit-2 text-kit-xs leading-none ${checked ? "bg-[var(--inyc-secondary)] text-[var(--inyc-secondary-text-color)]" : ""} `}>
            yes
          </div>
          <div onClick={handleChange(false)} className={`checkbox-yes-no-option duration-200 font-bold rounded-kit-2xl border border-[var(--inyc-outline-color)] px-kit-12 py-kit-2 text-kit-xs leading-none ${!checked ? "bg-[var(--inyc-secondary)] text-[var(--inyc-secondary-text-color)]" : ""} `}>
            no
          </div>
        </div>
      </div>
      {label && <div className="flex items-center h-full whitespace-nowrap text-kit-lg">{label}</div>}
    </div>
  );
};

export default CheckBoxYesNo;
